goog.provide('el8.appchart.dialog.ordermed.newDocumentDiscontinue');


goog.require('el8.appservice.notifier');
goog.require('el8.ptdata.medOrders');
goog.require('el8.ptdata.dcMedOrders');
goog.require('el8.ptdata.model.med.dcMedOrder');
goog.require('el8.uiwidget.FormDialog');
goog.require('el8.uiwidget.Form');
goog.require('el8.uiwidget.alert');
goog.require('el8.util.validate');
goog.require('el8.template.appchart.dialog.ordermed.newDocumentDiscontinue');
goog.require('el8.appchart.dialog.ordermed.base');
goog.require('el8.appchart.dialog.ordermed.util');
goog.require('el8.appchart.mgr.notes');


el8.appchart.dialog.ordermed.newDocumentDiscontinue = (function() {

    var that = new el8.uiwidget.FormDialog({
        title: 'Document Discontinued Med',
        autoHeight: true,
        width: 475,
        contentFn: el8.template.appchart.dialog.ordermed.newDocumentDiscontinue.content
    });

    var form = new el8.uiwidget.Form({
        fields: [
            {
                name: 'medication',
                selector: ':input[name="medication"]',
                infoText: 'med and strength...',
                maxLength: 100
            },
            {
                name: 'med-directions',
                selector: ':input[name="med-directions"]',
                infoText: 'directions...',
                maxLength: 100
            },
            {
                name: 'prescriber',
                selector: '.prescriber-field'
            },
            {
                name: 'startDate',
                selector: ':input[name="startDate"]',
                infoText: 'date med started...',
                datePickerOpts: {},
                validate: {
                    validDate: true,
                    todayOrBefore: true,
                    afterYear1900: true
                }
            },
            {
                name: 'notes',
                selector: ':input[name="notes"]',
                infoText: 'notes...',
                maxLength: 100
            },
            {
                name: 'reason',
                selector: ':input[name="reason"]',
                infoText: 'reason for discontinuing med...',
                maxLength: 100
            },
            {
                name: 'discontinueDate',
                selector: ':input[name="discontinueDate"]',
                infoText: 'date discontinued...',
                datePickerOpts: {},
                validate: {
                    validDate: true,
                    todayOrBefore: true,
                    afterYear1900: true
                }
            },
            {
                name: 'dcPrescriber',
                selector: '.dc-prescriber-field'
            }
        ],
        validationOpts: el8.util.validate.standardOpts
    });
    form.addButton('save-and-add', 'Save & Add Another', function(_form) {
        that._doSave(true);
    }, true);
    form.addButton('save', 'Save & Close', function(_form) {
        that._doSave(false, function() {
            that.hide();
        });
    });
    form.addDiscardButton(function() {
        that.hide();
    });
    that.setForm(form);

    var super_init = that._init;
    that._init = function() {

        super_init.call(that);
        that.getDialogContainer().attr('id', 'new-document-dc-dialog');

        that.reloadVitalsFn = el8.appchart.dialog.ordermed.util.initPatientVitalsPanel(
            $('.meds-form-pt-vitals', that.getDialogContainer()),
            $('.meds-form-pt-vitals fieldset', that.getDialogContainer())
        );
    };

    var super_show = that.show;
    that.show = function() {

        super_show.call(that);

        /**
         * Lame-o, but we need to make sure the form renders before initializing
         * baseMedForm, so this can't be put into that._init
         */
        if (!that._baseMedForm) {
            that._baseMedForm = new el8.appchart.dialog.ordermed.base({
                container: that.getContentElt(),
                medicationField: form.getInfoField('medication'),
                directionsField: form.getInfoField('med-directions'),
                notesField: form.getInfoField('notes'),
                startDateField: form.getInfoField('startDate'),
                prescriberField: $('.prescriber-field', that.getContentElt()),
                dcReasonField: form.getInfoField('reason'),
                dcPrescriberField: $('.dc-prescriber-field', that.getContentElt()),
                dcDateField: form.getInfoField('discontinueDate'),
                patientInfoDiv: $('#new-document-dc-cds', that.getContentElt())
            });
            that._baseMedForm.init();
        }

        that._baseMedForm.initForms();
        form.initFocus();

        // TODO: replace with Promise.always() in jQuery 1.6+
        that.reloadVitalsFn()
            .done(function() { that.adjustHeight(); })
            .fail(function() { that.adjustHeight(); });

        that.adjustHeight();
    };

    var super_hide = that.hide;
    that.hide = function() {
        that._reset();
        super_hide.call(that);
    };
    that._reset = function() {
        that._baseMedForm.reset();
    };

    /**
     * Helper functions
     */
    that._doSave = function(addAnother, callbackFn) {
        form.disable();

        var medOrder = that.getMedOrder();
        var dcMedOrder = that.getDcMedOrder();
        var validated = that._validate(medOrder, dcMedOrder);

        if (!validated.result) {
            el8.uiwidget.alert(validated.msg);
            form.enable();
        } else {
            el8.appservice.notifier.notify('Saving...');
            el8.ptdata.medOrders.saveItem(medOrder, false, {
                successCb: function(item) {
                    el8.appchart.mgr.notes.addNewOrder(item);
                    dcMedOrder.setMedOrderId(item.getId());
                },
                async: false
            });
            el8.ptdata.dcMedOrders.saveItem(dcMedOrder, false, {
                successCb: function(item) {
                    el8.appchart.mgr.notes.addNewOrder(item);
                    if (callbackFn) { callbackFn(); }
                    if (addAnother) {
                        that._reset();
                        that.show();
                    }
                }
            });
        }
    };
    that._validate = function(medOrder, dcMedOrder) {

        /* First validate medOrder */
        var medValidated = that._baseMedForm.validate(medOrder);
        if (!medValidated.result) {
            return medValidated;
        }

        /* Now do validation on dc part */
        if (!dcMedOrder.getDiscontinueDate()) {
            return {result: false, msg: 'Please enter a discontinue date.'};
        } else if (medOrder.getStartDate().getTime() > dcMedOrder.getDiscontinueDate().getTime()) {
            return {result: false, msg: 'The discontinue date cannot be earlier than the start date'};
        }

        return {result: true};

    };
    that.getMedOrder = function() {
        return that._baseMedForm.getMedOrder(null, true);
    };
    that.getDcMedOrder = function() {
        var dcPrescriberInfo = el8.appchart.dialog.ordermed.util.extractPrescriberInfo(
            that._baseMedForm.getDcPhysicianSearchField(),
            form.getInfoField('dcPrescriber')
        );
        return el8.ptdata.model.med.dcMedOrder({
            model_class: 'DiscontinueMedOrder',
            med_order_id: null,
            reason: form.getVal('reason'),
            discontinue_date: form.getVal('discontinueDate'),
            is_documented: true,
            prescribing_physician_id: dcPrescriberInfo['prescribingPhysicianId'],
            manual_prescribing_physician_name: dcPrescriberInfo['prescriberName']
        });
    };

    return that;

})();
